import { useTranslations } from 'next-intl';
import Text from '@atoms/Text/Text';
import Heading from '@atoms/Heading/Heading';

import { StyledAnimalInfo, StyledHeader } from './ProductTableOfContents.styles';
import { AxfoodProductDetailsViewModel, ProductInfoNutrientComponentData } from '@occ/api-client';
import { Fragment } from 'react';
import sortNutrientComponents from '@helpers/sortNutrientComponents';

interface Props {
  product: AxfoodProductDetailsViewModel;
}

const ProductTableOfContents = ({ product }: Props) => {
  const t = useTranslations('product');

  const { ingredients, nutrientComponents, animalData } = product;
  const { compositionStatement, constituentStatement, additiveStatement } = animalData || {};

  const sortedNutrientComponents = sortNutrientComponents(nutrientComponents);

  return (
    <>
      {!animalData && (ingredients || sortedNutrientComponents.length > 0) && (
        <>
          {sortedNutrientComponents.length > 0 ? (
            sortedNutrientComponents.map((nutrientComponent: ProductInfoNutrientComponentData) => (
              <Fragment key={nutrientComponent.sequenceNumber}>
                <StyledHeader type="label" size="small">
                  {nutrientComponent.description}
                </StyledHeader>
                <Text type="body">{nutrientComponent?.ingredientStatement}</Text>
              </Fragment>
            ))
          ) : (
            <>
              <StyledHeader type="label" size="small">
                {t('contents')}
              </StyledHeader>
              <Text type="body">{ingredients}</Text>
            </>
          )}
        </>
      )}

      {animalData && (
        <>
          {compositionStatement && (
            <StyledAnimalInfo>
              <Heading variant="h3" label>
                {t('animalData.compositionStatement')}
              </Heading>
              <Text type="body">{compositionStatement}</Text>
            </StyledAnimalInfo>
          )}
          {constituentStatement && (
            <StyledAnimalInfo>
              <Heading variant="h3" label>
                {t('animalData.constituentStatement')}
              </Heading>
              <Text type="body">{constituentStatement}</Text>
            </StyledAnimalInfo>
          )}
          {additiveStatement && (
            <StyledAnimalInfo>
              <Heading variant="h3" label>
                {t('animalData.additiveStatement')}
              </Heading>
              <Text type="body">{additiveStatement}</Text>
            </StyledAnimalInfo>
          )}
        </>
      )}
    </>
  );
};

export default ProductTableOfContents;
